import { chakra, Flex } from "@chakra-ui/react";
import classNames from "classnames";
import React, { ReactNode } from "react";
import { WithClassName } from "@/types/base";

import Icon from "@/components/Icon";
import { ReactComponent as ArrowSvg } from "@/assets/icons/arrow-down.svg";
import { genBlock } from "@/utils/bem";

import "./style.scss";

const CharkrarifiedIcon = chakra(Icon, {
  baseStyle: {
    flexShrink: 0,
    h: "10px",
  },
});

const block = genBlock("c-expandable-text");

const IExpandableText = React.forwardRef<
  HTMLDivElement,
  WithClassName<{
    children: ReactNode;
    iconClassName?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    open?: boolean;
  }>
>(({ children, className, iconClassName, onClick, open }, ref) => {
  return (
    <Flex
      className={classNames(block(), className, { open })}
      w="100%"
      color="text.secondary"
      fontSize="sm"
      display="inline-flex"
      wordBreak="break-word"
      onClick={onClick}
      tabIndex={0}
      ref={ref}
      alignItems="center"
    >
      <chakra.span display="inline-flex" minH="22px" alignItems="center" lineHeight="1.2">
        {children}
      </chakra.span>
      <CharkrarifiedIcon
        className={classNames(block({ e: "arrow" }), iconClassName)}
        svg={ArrowSvg}
        transform="rotate(-90deg)"
      />
    </Flex>
  );
});

export const ExpandableText = chakra(IExpandableText);
